import { render, staticRenderFns } from "./StatsKpiColumnGoal.vue?vue&type=template&id=88d7b024&scoped=true&"
import script from "./StatsKpiColumnGoal.vue?vue&type=script&lang=js&"
export * from "./StatsKpiColumnGoal.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiColumnGoal.vue?vue&type=style&index=0&id=88d7b024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d7b024",
  null
  
)

export default component.exports